export function GetDate(dias = 0, meses = 0) {
  var fecha = new Date();
  fecha.setDate(fecha.getDate() + dias);
  fecha.setMonth(fecha.getMonth() + meses);
  const year = fecha.getFullYear();
  const month = fecha.getMonth() + 1;
  const day = fecha.getDate();

  //console.log("ACTUAL: ", year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day))

  return (
    year +
    "-" +
    (month < 10 ? "0" + month : month) +
    "-" +
    (day < 10 ? "0" + day : day)
  );
}

export const formatDateFrontDeBack = (fecha) => {
  if (fecha && typeof fecha == "string") {
    if (fecha.includes("-")) {
      const [anio, mes, dia] = fecha.split("-");
      return [dia, mes, anio].join("/");
    }
  }

  return "";
};

export const formatDateBackDeFront = (fecha) => {
  if (fecha && typeof fecha == "string") {
    if (fecha.includes("/")) {
      const [dia, mes, anio] = fecha.split("/");
      return [anio, mes, dia].join("-");
    }
  }

  return "";
};

export function ConvertTime(fecha) {
  if (typeof fecha == "object" && fecha) {
    let fechaFormateada = "";
    const hh = fecha["$H"];
    const mm = fecha["$m"];
    fechaFormateada =
      (hh < 10 ? "0" + hh : hh) + ":" + (mm < 10 ? "0" + mm : mm) + ":00";
    return fechaFormateada;
  } else {
    return fecha;
  }
}

export function ConvertDate(fecha) {
  if (typeof fecha == "object" && fecha) {
    let fechaFormateada = "";
    let yyyy = fecha["$y"];
    let mm = fecha["$M"] + 1;
    let dd = fecha["$D"];
    fechaFormateada =
      yyyy + "-" + (mm < 10 ? "0" + mm : mm) + "-" + (dd < 10 ? "0" + dd : dd);
    return fechaFormateada;
  } else {
    return fecha;
  }
}

export const isValidDate = (d) => {
  let valido = d instanceof Date && !isNaN(d);
  if (!valido) {
    if (typeof d == "string") {
      valido = d.includes("-");
    }
  }
  return valido;
};
